import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, CanDeactivateGuard } from '../_guards';
import { ResolveActionType } from '../_models';
import { ResolveSettingsComponent, ResolveActionConfigComponent, RequestRefundSettingsComponent } from '.';

const routes: Routes = [
  {
    path: 'resolve-settings',
    data: { title: 'Resolve Settings' },
    children: [
      {
        path: '',
        component: ResolveSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'view-order',
        data: { title: 'Resolve Settings - View Order', actionType: ResolveActionType.ViewOrder },
        component: ResolveActionConfigComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'buy-again',
        data: { title: 'Resolve Settings - Buy Again', actionType: ResolveActionType.BuyAgain },
        component: ResolveActionConfigComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'request-refund',
        data: { title: 'Resolve Settings - Request Refund' },
        component: RequestRefundSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResolveSettingsRoutingModule {}
